import {ReactNode} from 'react';
import {Navigate} from 'react-router-dom';
import {PATHS} from 'routes/constants';
import {useVerificationSettings} from 'hooks/iv/useVerificationSettings';
import {useReservation} from 'context/reservation';
import {usePath} from 'hooks';

type IVVerifiedContactsGuardProps = {
  children: ReactNode;
};

function IVVerifiedContactsGuard({children}: IVVerifiedContactsGuardProps) {
  const {housing} = useReservation();
  const {getFullPath} = usePath();
  const {isNeedVerification} = useVerificationSettings(housing?.id);

  if (isNeedVerification) {
    return <Navigate to={getFullPath(PATHS.verification.contacts)} replace />;
  }

  return <>{children}</>;
}

export {IVVerifiedContactsGuard};
